interface IModalNotification {
  titleKey: string;
  messageKey: string;
  identifier: string;
  element?: React.JSX.Element;
}

export class ModalNotification {
  titleKey: string;
  messageKey: string;
  identifier: string;
  element?: React.JSX.Element;

  constructor(notification?: IModalNotification) {
    this.titleKey = notification?.titleKey ?? "";
    this.messageKey = notification?.messageKey ?? "";
    this.identifier = notification?.identifier || "";
    this.element = notification?.element;
  }
}
